import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';
import LazyImage from './LazyImage';
import TextWithCut from './TextWithCut';

function Catalog({info}) {
    const navigate = useNavigate();
    const params = useParams();
    const slug = params['*'];

    const handleItemClick = (path) => {
        navigate(`/${slug}/${path}`);
    };

    const cols = info.extra?.elementsInARow || 3;
    const content = info.extra?.content || '';
    const descriptionCut = info.extra?.description_cut || 'none';

    const rows = info.extra?.rows || [];
    const allProperties = rows.flatMap(row => row.columns || []).flatMap(col => col.properties || []);
    const titleProp = allProperties.find(p => p.as_title === true);
    const subtitleProp = allProperties.find(p => p.as_subtitle === true);

    const getItemTitle = (page) => {
        if (titleProp) {
            const val = page.extra?.props?.[titleProp.name];
            if (val) return val;
        }
        return page.caption || page.title;
    };

    const formatDate = (value) => {
        const [y, m, d] = value.split('-').map(Number);
        const date = new Date(y, m - 1, d);
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        return `${month} ${date.getDate()}, ${date.getFullYear()}`;
    };

    const getItemSubtitle = (page) => {
        if (!subtitleProp) return null;
        let val = page.extra?.props?.[subtitleProp.name];
        if (!val) return null;
        if (subtitleProp.type === 'date') val = formatDate(val);
        const prefix = subtitleProp.meta?.prefix || '';
        const suffix = subtitleProp.meta?.suffix || '';
        return [prefix, val, suffix].filter(Boolean).join(' ');
    };

    return (
        <div className="justify" style={{ width: '100%' }}>
            {info.caption && !(typeof content === "string" && content) && <h1>{info.caption}</h1>}
            {typeof content === "string" && content ? (
                <TextWithCut cut={descriptionCut} value={parse(content)} />
            ) : null}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${cols}, 1fr)`,
                    gap: "12px",
                    width: "100%"
                }}
            >
                {(info.children || []).map((page, idx) => (
                    <div key={idx} className="category-block" onClick={() => handleItemClick(page.slug)} style={{ cursor: "pointer" }}>
                        <div style={{ overflow: "hidden" }}>
                            {page.preview ? (
                                <LazyImage
                                    src={page.preview}
                                    alt={page.title}
                                    className="catalog-image"
                                    style={{ aspectRatio: "16 / 9", width: "100%" }}
                                    imgStyle={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
                                />
                            ) : (
                                <div className="catalog-image" style={{ backgroundColor: "#f0ebe0", aspectRatio: "16 / 9", width: "100%" }} />
                            )}
                        </div>
                        <div style={{ padding: "8px 4px 0" }}>
                            <span className="imageTitle">{getItemTitle(page)}</span>
                            {getItemSubtitle(page) && (
                                <div className="imageMaterial">{getItemSubtitle(page)}</div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {slug.split('/').length > 1 &&
                <button
                    className="btn-back"
                    onClick={() => navigate(`/${slug.split('/').slice(0, -1).join('/')}`)}
                >
                    Go Back
                </button>
            }
        </div>
    );
}

export default Catalog;
